import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = { class: "ml-auto" }
const _hoisted_3 = { class: "mr-3" }
const _hoisted_4 = {
  key: 0,
  class: "bar-mostrine"
}
const _hoisted_5 = { class: "confirmation-content" }
const _hoisted_6 = { class: "confirmation-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("li", {
      class: ["channel-row d-flex", { 'position-relative': _ctx.showBar }]
    }, [
      _createVNode("div", null, [
        _createVNode("span", {
          class: ["device-slot-dot", [_ctx.slotDotClass, _ctx.slotIcon]]
        }, null, 2),
        _createVNode("span", _hoisted_1, _toDisplayString(_ctx.slotName) + " " + _toDisplayString(_ctx.objectSlot.index), 1)
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.linkDescription), 1),
        (_ctx.isCommutable)
          ? (_openBlock(), _createBlock(_component_Checkbox, {
              key: 0,
              binary: true,
              modelValue: _ctx.isSlotSelected,
              disabled: _ctx.isAdd,
              onClick: _ctx.toggleSlot
            }, null, 8, ["modelValue", "disabled", "onClick"]))
          : (_openBlock(), _createBlock(_component_InlineSvgScoped, {
              key: 1,
              class: "checkbox-fake-disabled",
              src: 
                    require(`@/assets/images/icons/icon-checkbox-disabled.svg`)
                ,
              "aria-label": "icon-checkbox-disabled"
            }, null, 8, ["src"]))
      ]),
      (_ctx.showBar)
        ? (_openBlock(), _createBlock("span", _hoisted_4))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.popupData)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          header: _ctx.popupData.warningTitle,
          visible: _ctx.popupData.isWarningRequested,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.popupData.isWarningRequested = $event)),
          visibleModifiers: { sync: true },
          style: { width: '350px' },
          modal: true
        }, {
          footer: _withCtx(() => [
            (_ctx.popupData.isConfirmation)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_Button, {
                    label: _ctx.$t('AppResource.No'),
                    onClick: _ctx.doNoCommandBtn,
                    class: "p-button-text"
                  }, null, 8, ["label", "onClick"]),
                  _createVNode(_component_Button, {
                    label: _ctx.$t('AppResource.Yes'),
                    onClick: _ctx.doYesCommandBtn,
                    class: "p-button-text",
                    autofocus: ""
                  }, null, 8, ["label", "onClick"])
                ], 64))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  label: _ctx.$t('AppResource.Ok'),
                  onClick: _ctx.doAlertCommandBtn,
                  class: "p-button-text",
                  autofocus: ""
                }, null, 8, ["label", "onClick"]))
          ]),
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("span", null, _toDisplayString(_ctx.popupData.warningMessage), 1)
            ])
          ]),
          _: 1
        }, 8, ["header", "visible"]))
      : _createCommentVNode("", true),
    (_ctx.popupData)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 1,
          header: _ctx.popupData.warningTitle,
          visible: _ctx.popupData.isPresetWarningRequested,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.popupData.isPresetWarningRequested = $event)),
          visibleModifiers: { sync: true },
          style: { width: '350px' },
          modal: true
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: _ctx.$t('AppResource.No'),
              onClick: _ctx.doPresetNoCommandBtn,
              class: "p-button-text"
            }, null, 8, ["label", "onClick"]),
            _createVNode(_component_Button, {
              label: _ctx.$t('AppResource.Yes'),
              onClick: _ctx.doPresetYesCommandBtn,
              class: "p-button-text",
              autofocus: ""
            }, null, 8, ["label", "onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", null, _toDisplayString(_ctx.popupData.warningMessage), 1)
            ])
          ]),
          _: 1
        }, 8, ["header", "visible"]))
      : _createCommentVNode("", true)
  ], 64))
}